

















import { defineComponent, onMounted, computed, onActivated } from '@vue/composition-api';
import { useStore } from '@/store';
import FixedBar from '@/components/List/FixedBar.vue';
import ListViewHeader from '@/components/Navigation/ListViewHeader.vue';
import LoadingIcon from '@/components/UI/LoadingIcon.vue';
import VehicleItem from '@/components/List/VehicleItem.vue';
import { ActionTypes } from '@/store/actions';
import { MutationTypes } from '@/store/mutations';
import ScrollLoader from '@/components/List/ScrollLoader.vue';

export default defineComponent({
    name: 'ListView',
    components: { ScrollLoader, VehicleItem, FixedBar, ListViewHeader, LoadingIcon },
    created () {
        document.title = 'Used Cars NI View';
    },
    setup () {
        const store = useStore();
        const items = computed(() => store.getters.listItems);
        const data = computed(() => store.state.listCache);
        const loading = computed(() => store.state.isListLoading);

        onMounted(() => {
            store.dispatch(ActionTypes.InitListView);
        });

        onActivated(() => {
            store.commit(MutationTypes.SetCheckIfNeedToLoadMoreItems, true);
        });

        return { items, loading, data };
    }
});
